<h2 *ngIf="grafData.length > 0">Estado de almacenes</h2>
<div class="container-fluid">
    <div class="row">

        <!-- Pedidos pendientes-->
        <div class="col-md-3"
             [hidden]="!mostrarPedidosPendientes">
            <app-panel-pedidos-pendientes (tieneContenido)="mostrarPedidosPendientes = $event">
            </app-panel-pedidos-pendientes>
        </div>


        <!-- Entradas pendientes-->
        <div class="col-md-3"
             [hidden]="!mostrarEntradasPendientes">
            <app-panel-entradas-pendientes (tieneContenido)="mostrarEntradasPendientes = $event">
            </app-panel-entradas-pendientes>
        </div>


        <!-- Almacenes -->
        <div *ngFor="let item of grafData"
             class="col-md-3">
            <div class="card shadow-lg border-0 rounded-4 overflow-hidden h-100"
                 style="background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(10px);">
                <div class="card-body">
                    <h5 class="card-title text-center "><span class="text-secondary">{{ item.almacen.codigo }}</span> <strong> {{ item.almacen.nombre }}</strong></h5>
                    <div style="display: block;">
                        <canvas baseChart
                                [data]="item.chartData"
                                [type]="doughnutChartType"
                                (chartHover)="chartHovered($event)"
                                (chartClick)="chartClicked($event)">
                        </canvas>
                    </div>
                    <div class="mt-3 text-center">
                        <p class="mb-1"><strong>Capacidad:</strong> {{ item.totalAlmacen | number: '1.0-0' }} Ubicaciones</p>
                        <p class="mb-1"><strong>Ocupadas:</strong> {{ item.ocupados | number: '1.0-0' }} ({{ item.porcentajeOcupadas | number: '1.2-2' }}%)</p>
                        <p class="mb-0 text-success"><strong>Libres:</strong> {{ item.totalAlmacen - item.ocupados | number: '1.0-0' }} ({{ item.porcentajeLibres | number: '1.2-2' }}%)</p>
                        <hr *ngIf="item.campanyasPendientes">
                        <p *ngIf="item.campanyasPendientes"
                           class="mb-0 text-info"><strong>Campañas pendientes:</strong> {{ item.campanyasPendientes }}</p>
                    </div>
                </div>
            </div>
        </div>


        <!-- Fragmentación de stock por clientes -->
        <div class="col-md-6"
             [hidden]="!mostrarFragmentacionStock">
            <app-fragmentacion-stock (tieneContenido)="mostrarFragmentacionStock = $event">
            </app-fragmentacion-stock>
        </div>

    </div>

    <!-- Evolución de Pedidos -->
    <span *ngIf="chartServidosData">
        <br>
        <hr>
    </span>

    <div class="row animated fadeIn"
         *ngIf="chartServidosData">
        <div class="col-12">
            <h2 class="mb-4">Evolución de Pedidos (Últimos 12 meses)</h2>
        </div>

        <!-- Gráfico Servidos -->
        <div class="col-md-6 mb-4">
            <div class="card shadow-lg border-0 rounded-4 overflow-hidden h-100"
                 style="background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(10px);">
                <div class="card-header bg-transparent border-0 pt-4 px-4">
                    <h5 class="card-title mb-0 d-flex align-items-center">
                        <i class="mdi mdi-check-circle-outline text-success me-2 mr-2"
                           style="font-size: 24px;"></i>
                        Pedidos Servidos
                        <span class="badge bg-success text-white rounded-pill px-3 ms-auto ml-auto"
                              style="font-size: 0.9rem;">
                            Total: {{ totalesServidos | number:'1.0-0' }}
                        </span>
                    </h5>
                </div>
                <div class="card-body p-4">
                    <div style="display: block; height: 350px;">
                        <canvas baseChart
                                [data]="chartServidosData!"
                                [options]="lineChartOptions"
                                [type]="'line'">
                        </canvas>
                    </div>
                </div>
            </div>
        </div>

        <!-- Gráfico Incidencias -->
        <div class="col-md-6 mb-4">
            <div class="card shadow-lg border-0 rounded-4 overflow-hidden h-100"
                 style="background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(10px);">
                <div class="card-header bg-transparent border-0 pt-4 px-4">
                    <h5 class="card-title mb-0 d-flex align-items-center">
                        <i class="mdi mdi-alert-circle-outline text-danger me-2 mr-2"
                           style="font-size: 24px;"></i>
                        Cancelaciones e Incidencias
                        <span class="badge bg-danger text-white rounded-pill px-3 ms-auto ml-auto"
                              style="font-size: 0.9rem;">
                            Total: {{ totalesIncidencias | number:'1.0-0' }}
                        </span>
                    </h5>
                </div>
                <div class="card-body p-4">
                    <div style="display: block; height: 350px;">
                        <canvas baseChart
                                [data]="chartIncidenciasData!"
                                [options]="lineChartOptions"
                                [type]="'line'">
                        </canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Entradas de mercancia -->
    <app-panel-entradas></app-panel-entradas>




</div> <!-- /.container-fluid -->